import type { HomeApiResponse } from '@/domains/home/home.entity';

/**
 * Use Case para filtrar datos de Home excluyendo años futuros
 * Cumple SRP: Solo filtra años que no excedan el año actual del sistema
 *
 * Responsabilidades:
 * - Obtener año actual del sistema
 * - Filtrar apiResponse.data para excluir años > año actual
 * - Retornar estructura HomeApiResponse con data filtrada
 *
 * Caso de uso: Prevenir inconsistencias cuando la API devuelve datos de años futuros
 */
export class FilterHomeDataByCurrentYearUseCase {
  execute(apiResponse: HomeApiResponse): HomeApiResponse {
    if (!apiResponse?.data) {
      return apiResponse;
    }

    const currentYear = new Date().getFullYear();

    const filteredData = apiResponse.data.filter(
      (yearData) => yearData.ano <= currentYear,
    );

    return {
      ...apiResponse,
      data: filteredData,
    };
  }
}
